import Mesh3D from './Mesh3D';
import { ShaderProgram } from '../rendering/Shader';
import Renderer from '../rendering/Renderer';

export default class Mesh3D_TRIANGLE_normal_texture extends Mesh3D {

	constructor (geometry) {
		super(geometry);
	}

	createVertexBuffer (geometry) {
		const triangles = geometry.faces;
		const positions = geometry.positions;
		const normals = geometry.normals;
		const uvs = geometry.uvs;

		const vertexSize  = 28;
		this.vertexCount = triangles.length * 3;

		// Populating vertex buffer
		this.vertexBuffer = new ArrayBuffer(this.vertexCount * vertexSize);
		const floatView  = new Float32Array(this.vertexBuffer);
		const longView  = new Uint32Array(this.vertexBuffer);

		let index = 0;
		for (let t = 0; t < triangles.length; t++) {
			const triangle = triangles[t];
			const vertexIndexes = triangle.vertices;
			const normalIndexes = triangle.normals;

			const a = positions[vertexIndexes.x];
			const b = positions[vertexIndexes.y];
			const c = positions[vertexIndexes.z];

			const na = normals[normalIndexes.x];
			const nb = normals[normalIndexes.y];
			const nc = normals[normalIndexes.z];

			const uva = uvs[vertexIndexes.x];
			const uvb = uvs[vertexIndexes.y];
			const uvc = uvs[vertexIndexes.z];

			floatView[index + 0] = a.x;
			floatView[index + 1] = a.y;
			floatView[index + 2] = a.z;

			floatView[index + 3] = na.x;
			floatView[index + 4] = na.y;
			floatView[index + 5] = na.z;

			longView[index + 6] = (uva.x * 0xffff & 0xffff) + (uva.y * 0xffff0000 & 0xffff0000);

			floatView[index + 7] = b.x;
			floatView[index + 8] = b.y;
			floatView[index + 9] = b.z;

			floatView[index + 10] = nb.x;
			floatView[index + 11] = nb.y;
			floatView[index + 12] = nb.z;

			longView[index + 13] = (uvb.x * 0xffff & 0xffff) + (uvb.y * 0xffff0000 & 0xffff0000);

			floatView[index + 14] = c.x;
			floatView[index + 15] = c.y;
			floatView[index + 16] = c.z;

			floatView[index + 17] = nc.x;
			floatView[index + 18] = nc.y;
			floatView[index + 19] = nc.z;

			longView[index + 20] = (uvc.x * 0xffff & 0xffff) + (uvc.y * 0xffff0000 & 0xffff0000);


			index += 21;
		}

		// const vertexSize  = 24;
		// this.vertexCount = faces.length * 3;

		// // Populating vertex buffer
		// this.vertexBuffer = new ArrayBuffer(positions.length * vertexSize);
		// const floatView  = new Float32Array(this.vertexBuffer);

		// let index = 0;
		// for (let v = 0; v < positions.length; v += 1) {
		// 	const position = positions[v];
		// 	const normal   = normals[v]; // Same number of positions and normals

		// 	floatView[index]     = position.x;
		// 	floatView[index + 1] = position.y;
		// 	floatView[index + 2] = position.z;

		// 	floatView[index + 3] = normal.x;
		// 	floatView[index + 4] = normal.y;
		// 	floatView[index + 5] = normal.z;
		// 	index += 6;
		// }

		// // Populating index buffer
		// this.indexBuffer = new Uint16Array(faces.length * 3);
		// const vertexIndexBuffer = this.indexBuffer;
		// index = 0;
		// for (let f = 0; f < faces.length; f++) {
		// 	const face = faces[f];
		// 	vertexIndexBuffer[index]     = face.a;
		// 	vertexIndexBuffer[index + 1] = face.b;
		// 	vertexIndexBuffer[index + 2] = face.c;

		// 	index += 3;
		// }
	}

	render (renderer: Renderer, program: ShaderProgram, withNormals: boolean) {
		const gl = renderer.gl;
		const rendererID = renderer.id;

		let buffers = this.bufferBinders[rendererID];
		if (buffers === undefined) {
			buffers = this.uploadVertexBuffers(renderer);
			// debugger
		}

		gl.bindBuffer(gl.ARRAY_BUFFER, buffers.vertex);
		// gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.index);

		const attributes = program.attributes;
		const bytesToNormal = 4 * 3;
		const bytesToUV = bytesToNormal + 4 * 3;
		const bytesPerVertex = bytesToUV + 2 * 2;
		gl.vertexAttribPointer(attributes.aVertexPosition, 3, gl.FLOAT, false, bytesPerVertex, 0);
		if (withNormals === true) {
			gl.vertexAttribPointer(attributes.aVertexNormal, 3, gl.FLOAT, true, bytesPerVertex, bytesToNormal);
		}
		gl.vertexAttribPointer(attributes.aUV, 2, gl.UNSIGNED_SHORT, true, bytesPerVertex, bytesToUV);

		// gl.drawElements(gl.TRIANGLES, this.vertexCount, gl.UNSIGNED_SHORT, 0);
		gl.drawArrays(gl.TRIANGLES, 0, this.vertexCount);
	}

}
